import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography, Button, Chip } from '@mui/material';
import client from '../../lib/api/client';

/**
 * 번호 하나로 들어오는 단 하나의 입구.
 *
 *   /go/BI_PJ_2026_09_005   영업기회 번호
 *   /go/BI_OD_2026_08_004   수주 번호
 *
 * 어디로 보낼지는 서버가 정한다. 주소에 목적지를 박아 두면, 나중에 "수주된 건은
 * 제조 화면으로" 처럼 규칙이 바뀌었을 때 이미 메일로 뿌려진 주소들이 전부 엉뚱한
 * 데로 간다. 주소에는 번호만 담고 목적지는 누를 때 정한다.
 *
 * 우리 일감은 수주 전과 후에 볼 화면이 다르다. 번호만 봐서는 알 수 없고 레코드의
 * 상태를 봐야 하는데, 그 판단이 화면마다 흩어지면 금방 어긋난다.
 */
const GoPage = () => {
  const { no } = useParams();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const res = await client.get(`/api/v1/common/locate?no=${encodeURIComponent(no)}`);
        const info = res.data?.info;
        if (!active) return;
        if (!info?.path) {
          setFailed(true);
          return;
        }
        // 히스토리에 안 남긴다. 뒤로가기를 눌렀을 때 여기로 돌아와 다시 튕기면 안 된다.
        navigate(info.path, { replace: true });
      } catch {
        if (active) setFailed(true);
      }
    })();

    return () => { active = false; };
  }, [no, navigate]);

  if (failed) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 10 }}>
        <Typography variant="h6">이 번호로 찾을 수 있는 자료가 없습니다</Typography>
        <Chip label={no} sx={{ fontFamily: 'monospace' }} />
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', maxWidth: '24rem' }}>
          번호가 맞는지, 지워진 자료는 아닌지 확인해 주세요.
        </Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button variant="outlined" onClick={() => navigate('/chancemng', { replace: true })}>
            영업기회 목록
          </Button>
          <Button variant="outlined" onClick={() => navigate('/project_orders', { replace: true })}>
            수주 목록
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
      <CircularProgress />
    </Box>
  );
};

export default GoPage;
